import { render, staticRenderFns } from "./action-require-message-item.vue?vue&type=template&id=603cde03&scoped=true&"
import script from "./action-require-message-item.vue?vue&type=script&lang=ts&"
export * from "./action-require-message-item.vue?vue&type=script&lang=ts&"
import style0 from "./action-require-message-item.vue?vue&type=style&index=0&id=603cde03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603cde03",
  null
  
)

export default component.exports